<template>
	<div v-loading="loading" class="content_list" :class="agentMobile ? 'content_list_lg' : ''">
		<div class="normal-list"><in-hospital-card v-for="(item, index) in list" :key="index" :info="item" @toDetail="toDetail"></in-hospital-card></div>
		<mescroll-empty v-if="nullFlg" :option="emptyOption"></mescroll-empty>
	</div>
</template>

<script>
// import patApi from 'api/pat.js'
import inHospitalCard from '../../components/inHospitalCard.vue'
import {getPatientInfo} from '../../../../api/appletApi'
import mescrollEmpty from '../../components/mescrollEmpty.vue'
export default {
  name: 'inHospital',
  components: {
    inHospitalCard,
    mescrollEmpty
  },
  data () {
    return {
      emptyOption: {
        use: true,
        icon: '/static/null.png',
        tip: '没有住院记录'
      },
      agentMobile: '',
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,

      searchType: 'consultations',
      navType: '8',
      listData: [
        // {
        // 	title: '主诊断名称',
        // 	hospitalName: '鹿城区五马街道社区卫生服务中医院',
        // 	checkTime: '2020/07/15  14:00',
        // 	navType: '8',
        // 	titTxt: '慢性胃炎'
        // }
      ],
      allList: [],
      patId: '',
      nullFlg: false,
      list: [],
      detailList: []
    }
  },
  created () {},
  mounted (option) {
    /*  uni.setNavigationBarTitle({
      title: '住院记录（' + option.patName + '）'
    }) */
    this.patId = this.$route.query.patId
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      let that = this
      getPatientInfo({
        infoType: 2,
        patId: this.patId
      })
        .then(data => {
          this.loading = false
          if (data.length === 0) {
            this.nullFlg = true
            return
          }
          this.list = data
          getPatientInfo({
            infoType: 3,
            patId: this.patId
          })
            .then(data => {
              that.detailList = data
            })
        })
    },
    toDetail (info) {
      let toClickInfo = this.detailList.find(function (item) {
        return info.bingRenZYID === item.bingRenID
      })
      toClickInfo.name = info.xingMing
      toClickInfo.sex = info.xingBieDM
      toClickInfo.age = info.nianLing + info.nianLingDW
      toClickInfo.bingAnHao = info.bingAnHao
      toClickInfo.ruYuanRQ = info.ruYuanRQ
      toClickInfo.chuYuanRQ = info.chuYuanRQ
      toClickInfo.ruYuanKSMC = info.ruYuanKSMC

      this.$router.push({name: 'inHospitalDetail', params: toClickInfo})
    }
  }
}
</script>

<style lang="scss" scoped>
/* page {
	background-color: #f6f6f6;
} */
.filter_comp_box {
	background-color: #4bcbc3;
}
.normal-list {
	margin-top: 12px;
	padding: 0 12px;
}
.list_none {
	width: 100%;
	text-align: center;
	font-size: 14px;
	color: #666;
	padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/inHospital/inHospital.vue